import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

/**
 * Renders a navigation item (technically a checkbox) for the genre filter
 */
const genreNavItem = (props) => {
  const { id, label, checked, count, ...inputProps } = props;
  /**
   * The onclick handler of the checkbox (and/or label)
   *
   * @param {Event} e - click event
   */
  const handleOnClick = (e) => {
    if (props.onChange) {
      props.onChange(e.target.checked);
    }
  };

  const checkedClass = checked ? 'currently-active' : '';

  const testId = `filterItem-${label.replace(/[^a-zA-Z0-9]/g, ' ').split(/\s+/)
    .join('-')
    .toLowerCase()}`;

  /**
   * Main render
   *
   * @returns {HTMLElement[]}
   */

  // do not pass checked as attribute to the input, since it will then become readonly, we use defaultChecked to set the value.
  delete inputProps.checked;
  // do not pass onChanged as we will handle this as onClick to prevent race conditions
  delete inputProps.onChange;
  return (
    <div className={`checkbox-wrapper genre-checkbox ${checkedClass}`}>
      <div className="styled-checkbox checkbox" data-test-id={testId}>
        <input
          id={id}
          checked={checked}
          className="styled-checkbox__input"
          onClick={handleOnClick}
          onChange={() => {}}
          type="checkbox"
          {...inputProps}
        />
        <label className="styled-checkbox__label" htmlFor={id}>{label}</label>
      </div>
      {count && <span className={checkedClass}>({count})</span>}
    </div>
  );
};
genreNavItem.propTypes = {
  id: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  checked: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
};

export default genreNavItem;
